import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../store";
import {
  getOfferResponses,
  deleteOfferResponse,
  exportExcel,
  exportPdf,
} from "./modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    offerResponses: state.offerResponseReducer.offerResponses,
    loggedUser: state.authReducer.loggedUser,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getOfferResponses,
      deleteOfferResponse,
      exportExcel,
      exportPdf,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
